module.exports = __webpack_public_path__ + "img/leesh0001_2.381bdffa.svg";